module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_mitosis_14-709c804663979c2794c0e2f7abf31f1f.jpg";